module.exports = __webpack_public_path__ + "img/2024big13.00103920.png";